import React from 'react';
import { BodyContentHeading } from '../../types';
import styles from './styles.module.scss';

type ContentsHeadingPropType = {
  component: any;
  id: number;
};

export const ContentsHeading: React.FC<ContentsHeadingPropType> = ({
  component,
  id,
}) => {
  const uid = `${id}-${component[0].paraText
    .replace(/\s/g, '-')
    .toLowerCase()}`;
  return (
    <span className={styles['contents-heading']}>
      <h2 id={uid}>
        {id}.&nbsp;
        <span
          dangerouslySetInnerHTML={{
            __html: component[0].paraText,
          }}
        ></span>
      </h2>
    </span>
  );
};
